
import conversation from "./conversation"
import rapport from "./rapport"
import classification from "./classification"

export default  {
    namespaced:true,
    modules:{
        conversation,
        rapport,
        classification,
        
    }
}